const initialState = {
	isLoading: false
};

const reducer = (state = initialState, { type }) => {
	switch (type) {
		default:
			return state;
	}
};

export default reducer;
